<template>
  <div class="banner_bottom_agile_info team dir-rtl">
    <div class="container">
      <h3 class="wthree_text_info">اعضای راد اَپ</h3>
      <div class="inner_w3l_agile_grids row d-flex justify-content-center">
        <div class="col-md-3 team-grids">
          <div class="thumbnail team-w3agile">
            <img
              src="https://radap.ir/imagesUploaded/other/vahidsaeedi.png"
              class="img-responsive"
              alt="وحید سعیدی راد"
              style="height:300px !important"
            />
            <div class="social-icons team-icons right-w3l fotw33">
              <div class="caption">
                <h4>وحید سعیدی راد</h4>
                <p>مدیر عامل</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 team-grids">
          <div class="thumbnail team-w3agile">
            <img
              src="https://radap.ir/imagesUploaded/other/faridsaeedi.png"
              class="img-responsive"
              alt="فرید سعیدی راد"
              style="height:300px !important"
            />
            <div class="social-icons team-icons right-w3l fotw33">
              <div class="caption">
                <h4>فرید سعیدی راد</h4>
                <p>عضو هیات مدیره</p>
              </div>
            </div>
          </div>
        </div>
      
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TeamMember",
};
</script>

<style scoped>
.social-icons.team-icons {
  position: unset;
  /* position: absolute; */
}
</style>